<template>
  <div class="my_documents">
    <v-row>
      <v-col cols="3">
        <v-file-input
          label="Добавить документы"
          multiple
          show-size
          counter
          name="files"
          v-model="files"
          accept=".doc,.docx,.xls,.xlsx,.pdf,.png,.tif,.jpeg,.jpg"
        />
      </v-col>
      <v-col cols="2">
        <v-btn color="success" :disabled="process || files === null" :loading="process" @click.prevent="send">Загрузить</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="docsList"
            class="elevation-1"
          >
            <template v-slot:item.realName="{ item }">
              <EditText v-model="item.realName"  :mimetype="item.type" @change="(newRealName)=>editFile(item,newRealName)"/>
            </template>
            <template v-slot:item.type="{ item }">
              {{ item.type.replace(".", "") }}
            </template>
            <template v-slot:item.createdAt="{ item }">
              {{ moment(item.createdAt).format("DD.MM.YYYY HH:mm:ss") }}
            </template>
            <template v-slot:item.actions="{ item }">
              <div style="display: flex; column-gap: 10px; align-items: center">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="onHover"
                      style="font-size: 18px"
                      :disabled="onDownload"
                      @click="() => download(item)"
                      >fa fa-download
                    </v-icon>
                  </template>
                  <span>Скачать</span>
                </v-tooltip>
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="onHover"
                      style="font-size: 22px"
                      :disabled="onRemove"
                      @click="() => remove(item)"
                      >delete
                    </v-icon>
                  </template>
                  <span>Удалить в Архив</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="archiveDocsList.length">
      <v-col cols="12">
        <h3>Архив:</h3>

        <v-card>
          <v-data-table
            :headers="headers"
            :items="archiveDocsList"
            class="elevation-1"
          >
            <template v-slot:item.realName="{ item }">
              <EditText v-model="item.realName"  :mimetype="item.type" @change="(newRealName)=>editFile(item,newRealName)"/>
            </template>
            <template v-slot:item.type="{ item }">
              {{ item.type.replace(".", "") }}
            </template>
            <template v-slot:item.createdAt="{ item }">
              {{ moment(item.createdAt).format("DD.MM.YYYY HH:mm:ss") }}
            </template>
            <template v-slot:item.actions="{ item }">
              <div style="display: flex; column-gap: 10px; align-items: center">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="onHover"
                      style="font-size: 18px"
                      :disabled="onDownload"
                      @click="() => download(item)"
                      >fa fa-download
                    </v-icon>
                  </template>
                  <span>Скачать</span>
                </v-tooltip>
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="onHover"
                      style="font-size: 18px"
                      @click="() => restore(item)"
                      >fa fa-undo
                    </v-icon>
                  </template>
                  <span>Восстановить</span>
                </v-tooltip>
                <v-tooltip left >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="onHover"
                      @click="() => removePermanently(item)"
                      >delete_forever
                    </v-icon>
                  </template>
                  <span>Удалить совсем</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from "moment";
import Swal from "sweetalert2";
import EditText from '../components/EditText.vue'

export default {
  name: "MyDocuments",
  components: {
    EditText,
  },
  data: () => ({
    moment,
    files: null,
    process: false,
    headers: [
      { text: "Наименование файла", value: "realName" },
      { text: "Тип", value: "type", width: "80px" },
      { text: "Добавлен", value: "createdAt" },
      { text: "Действия", value: "actions", width: "120px" },
    ],
    onRemove: false,
    onDownload: false,
  }),
  methods: {
    async send(){
      this.process = true
      try{
        !this.inn && Swal.fire({
        icon: "warning",
        title: "Ошибка!",
        text: "Что то не так сообщите в тех. поодержку!",

      });
        var ins = this.files.length;
        const FD = new FormData();
        for (var x = 0; x < ins; x++) {
          FD.append("files", this.files[x]);
        }
        FD.append("inn", this.inn);

        await this.$store.dispatch('fileToStorage',FD)
        setTimeout(()=>{
          this.init(this.companyINN)
          this.files = null
        },500)
      }finally{
        this.process = false
      }
    },
    async init(companyINN) {
      await this.$store.dispatch("getAllDocs", companyINN);
    },
    async download(item) {
      this.onDownload = true;
      try {
        await this.$store.dispatch("getFile", item);
      } finally {
        this.onDownload = false;
      }
    },
    remove(item) {
      Swal.fire({
        icon: "warning",
        title: "Внимание!",
        text: "Вы удаляете документы компании!",
        // showCloseButton: true,
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "green",
        confirmButtonText: "Удалить",
        cancelButtonText: "Отменить",
        preConfirm: async () => {
          this.onRemove = true;
          try {
            await this.$store.dispatch("deleteFile", item._id);
          } finally {
            this.onRemove = false;
          }
        },
      });
    },
    async removePermanently(item) {
      Swal.fire({
        icon: "warning",
        title: "Внимание!",
        text: "Вы удаляете документы компании Без возможности востановления!",
        // showCloseButton: true,
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "green",
        confirmButtonText: "Удалить",
        cancelButtonText: "Отменить",
        preConfirm: async () => {
          this.onRemove = true;
          try {
            await this.$store.dispatch("deleteFilePermanently", item._id);
          } finally {
            this.onRemove = false;
          }
        },
      });
    },
    async restore(item) {
      await this.$store.dispatch("restoreFile", item._id);
    },
    async editFile(item,newRealName){
      await this.$store.dispatch('editName',{...item, realName: newRealName})
    },
  },
  computed: {
    companyINN() {
      return this.$store.getters.getMyOrganisation.inn;
    },
    inn() {
      return this.$store.getters.getMyOrganisation.inn;
    },
    docsList() {
      return this.$store.getters.getDocs;
    },
    archiveDocsList() {
      return this.$store.getters.getArchiveDocs;
    },
  },
  watch: {
    companyINN(newInn) {
      this.init(newInn);
    },
  },
  mounted() {
    this.init(this.companyINN);
  },
};
</script>
<style lang="sass" scoped></style>
